/**
 * @module app.shared
 */

import { autoinject } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { version, IEssetteApplicationVersion } from 'version';

@autoinject
export class EssAppBadge {

    protected version: IEssetteApplicationVersion = version;

    constructor(protected readonly env: EnvironmentService) { }

}
